<template>
  <div class="function-page">
  <div style="display:flex;align-items:center;gap:16px;margin-bottom:20px;">
  <button class="back-dashboard-btn" @click="goDashboard">← 返回仪表盘</button>
    <h2>当前操作区服：{{ currentServerName }}</h2>
    
  </div>

    <!-- 顶部切换Tab按钮 -->
    <div class="btn-group">
    <!--
      <button
        class="func-btn"
        :class="{ active: currentTab === 'ba' }"
        @click="currentTab = 'ba'"
      >
        ba
      </button>
      -->
      <button
        class="func-btn"
        :class="{ active: currentTab === 'gate' }"
        @click="currentTab = 'gate'"
      >
        角色预创建
      </button>
      <button
        class="func-btn"
        :class="{ active: currentTab === 'db' }"
        @click="currentTab = 'db'"
      >
        查看角色数据
      </button>
      <button
        class="func-btn"
        :class="{ active: currentTab === 'login' }"
        @click="currentTab = 'login'"
      >
        查看角色账号信息
      </button>
      <button
        class="func-btn"
        :class="{ active: currentTab === 'world' }"
        @click="currentTab = 'world'"
      >
        野怪爆率武功经验用户屏蔽
      </button>
    </div>

    <div class="page-content">
      <!-- BA 模块 本地保留 -->
      <div v-show="currentTab === 'ba'" class="tab-panel">
        <h3>BA - 修改版本号</h3>
        <div class="form-row">
          <label>目标版本号：</label>
          <input v-model="baVer" type="number" placeholder="请输入版本号，如1200" class="input-box" />
          <button class="submit-btn" @click="saveVerInfo">发送保存信息</button>
          <!-- 新增刷新按钮 -->
          <button class="submit-btn" @click="getBaVersion">刷新当前版本</button>
        </div>
        <div class="res-text" v-if="baRes">返回结果：{{ baRes }}</div>
      </div>


      <!-- GATE 模块【已扩展】 -->
      <div v-show="currentTab === 'gate'" class="tab-panel">
        <h3>GATE - 角色预创建控制</h3>
        <div class="btn-row">
          <button class="open-btn" @click="openCreateRole">打开角色预创建</button>
          <button class="close-btn" @click="closeCreateRole">关闭角色预创建</button>
          <button class="submit-btn" @click="fetchGateData">刷新Gate数据</button>
        </div>
        <div style="margin:16px 0; font-size:16px;">
          <span>欲创建状态：</span>
          <span :style="{color: gateData.checked ? '#67c23a' : '#f56c6c'}">
            {{ gateData.checked ? "开启" : "关闭" }}
          </span>
        </div>

        <div class="form-row">
          <label>客户每次：</label>
          <input v-model.number="gateData.connCount" type="number" class="input-box" />
          <button class="submit-btn" @click="saveUserCount">保存客户每次数值</button>
        </div>
        <div class="form-row">
          <label>限制人数：</label>
          <input v-model.number="gateData.limitCount" type="number" class="input-box" />
          <button class="submit-btn" @click="saveLimitCount">保存限制人数数值</button>
        </div>

        <div class="res-text" v-if="gateRes">操作结果：{{ gateRes }}</div>
      </div>

      <!-- DB 外部组件 -->
      <DB v-show="currentTab === 'db'" :server-name="currentServerName" />

      <!-- Login 外部组件【修复组件名】 -->
      <Login v-show="currentTab === 'login'" :server-name="currentServerName" />

      <!-- World 外部组件 -->
      <World v-show="currentTab === 'world'" :server-name="currentServerName" />
    </div>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import { ref, reactive, watch } from 'vue'
// 引入外部页面组件
import DB from '@/pages/DBPage.vue'
import Login from '@/pages/Login.vue'
import World from '@/pages/world.vue'

const currentTab = ref('gate')

const route = useRoute()
const router = useRouter() // 实例化router

function goDashboard() {
  // 简单延迟跳转，给异步收尾时间，如果你后续还要完善isUnmounted再进一步优化
  setTimeout(()=>{
    router.push('/Dashboard')
  },30)
}

const currentServerName = ref('')

// Gate数据容器
const gateData = reactive({
  checked: false,
  connCount: 0,
  limitCount: 0
})

// 获取路由参数
const getServerName = () => {
  if (route.query.serverName) {
    currentServerName.value = route.query.serverName
  }
}

// 监听路由变化（防止重复进入页面参数不更新）
watch(
  () => route.query,
  (newQuery) => {
    if (!newQuery) return
    getServerName()
    // 切换区服自动拉取gate最新配置
    fetchGateData()
    getBaVersion()
  },
  { immediate: true }
)

// ================= BA 模块 =================
const baVer = ref('')
const baRes = ref('')
function saveVerInfo() {
  if (!baVer.value) {
    baRes.value = '请输入版本号'
    return
  }
  const targetVer = Number(baVer.value)
  const url = `https://log.wuxiahaojie.com/api/FUWUQI/fixVer?servername=${currentServerName.value}&ver=${targetVer}`
  fetch(url)
    .then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      return res.text()
    })
    .then(data => baRes.value = '返回结果：' + data)
    .catch(err => baRes.value = '请求失败：' + err.message)
}

async function getBaVersion() {
  if (!currentServerName.value) {
    baRes.value = "请先选择区服！"
    return
  }
  const url = `https://log.wuxiahaojie.com/api/FUWUQI/getVer?servername=${currentServerName.value}`
  let text = ""
  try {
    const res = await fetch(url)
    if (!res.ok) throw new Error(`http状态码:${res.status}`)
    text = await res.text()
    const json = JSON.parse(text)
    // ✅ 版本号在 msg 里面！
    baVer.value = Number(json.msg)
    baRes.value = "获取当前版本成功"
  } catch (err) {
    baRes.value = "获取版本失败：" + err.message
    console.log("getVer原始返回：", text)
  }
}

// ================= GATE 模块 =================
const gateRes = ref('')

// 拉取Gate全部数据 GetData接口
async function fetchGateData() {
  if (!currentServerName.value) {
    gateRes.value = "请先选择区服！"
    return
  }
  const url = `https://log.wuxiahaojie.com/api/FUWUQI/GetData?servername=${currentServerName.value}`
  try {
    const res = await fetch(url)
    if (!res.ok) throw new Error(`状态码:${res.status}`)
    const json = await res.json()
    gateData.checked = json.checked
    gateData.connCount = json.connCount
    gateData.limitCount = json.limitCount
    gateRes.value = "Gate数据刷新成功"
  } catch (err) {
    gateRes.value = "刷新Gate数据失败：" + err.message
  }
}

// 修改客户每次 connCount
function saveUserCount() {
  if (!currentServerName.value) {
    gateRes.value = "请先选择区服！"
    return
  }
  const count = gateData.connCount
  const url = `https://log.wuxiahaojie.com/api/FUWUQI/userCount?servername=${currentServerName.value}&count=${count}`
  fetch(url)
    .then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      return res.text()
    })
    .then(data => {
      gateRes.value = `客户每次数值保存成功：${data}`
      fetchGateData() // 保存后刷新最新数据
    })
    .catch(err => gateRes.value = "保存失败：" + err.message)
}

// 修改限制人数 limitCount
function saveLimitCount() {
  if (!currentServerName.value) {
    gateRes.value = "请先选择区服！"
    return
  }
  const count = gateData.limitCount
  const url = `https://log.wuxiahaojie.com/api/FUWUQI/limitUserCount?servername=${currentServerName.value}&count=${count}`
  fetch(url)
    .then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      return res.text()
    })
    .then(data => {
      gateRes.value = `限制人数数值保存成功：${data}`
      fetchGateData() // 保存后刷新最新数据
    })
    .catch(err => gateRes.value = "保存失败：" + err.message)
}

// 打开预创建（修复模板字符串BUG）
function openCreateRole() {
  if (!currentServerName.value) {
    gateRes.value = "请先选择区服！"
    return
  }
  fetch(`https://log.wuxiahaojie.com/api/FUWUQI/open?servername=${currentServerName.value}`)
    .then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      return res.text()
    })
    .then(data => {
      gateRes.value = '打开成功：' + data
      //fetchGateData()
    })
    .catch(err => gateRes.value = '打开失败：' + err.message)
}

// 关闭预创建（修复模板字符串BUG）
function closeCreateRole() {
  if (!currentServerName.value) {
    gateRes.value = "请先选择区服！"
    return
  }
  fetch(`https://log.wuxiahaojie.com/api/FUWUQI/close?servername=${currentServerName.value}`)
    .then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      return res.text()
    })
    .then(data => {
      gateRes.value = '关闭成功：' + data
      //fetchGateData()
    })
    .catch(err => gateRes.value = '关闭失败：' + err.message)
}

// ====================== DB相关所有代码原样保留 ======================
// DB内部子面板标记
const dbSubTab = ref('base')
const searchName = ref('')
const roleList = ref([])
const selectRole = ref('')
const dbRes = ref('')

// 1.基础属性base数据
const roleData = reactive({
  name: "", id: "", account: "", bagPwd: "", teamId: 0, school: "",
  loginTime: "", createTime: "", gender: "男", mapId: 1, x: 0, y: 0,
  gold: 0, rep: 0, light: 0, dark: 0, maxVital: 0, soul1: 0, maxNei: 0,
  maxWai: 0, maxWu: 0, maxHuo: 0, talent: 0, goodChar: 0, badChar: 0,
  adaptive: 0, revival: 0, immunity: 0, haoran: 0, nowVital: 0, nowNei: 0,
  nowWai: 0, nowWu: 0, nowHuo: 0, soul2: 0, health: 0, satiety: 0, poison: 0,
  defHead: 0, defHand: 0, defLeg: 0, extraExp: 0, addPoint: 0, totalPoint: 0,
  grade: 0, fashionMode: 0, job: 0, soul3: 0, talentPoint: 0, talentExp: 0,
  talentLv: 0, gen: 0, shen: 0, wu: 0, wuxue: 0, bindCoin: 0, expRate: 0,
  expTime: 0, vipLv: 0, vipTime: "", makeLv: 0, schoolCoin: 0
})

// 2.武功magic 10行模板
const magicList = ref(Array.from({ length: 10 }, () => reactive({ lkey: 0, rname: "", rskill: 0 })))
// 3.物品item 16行模板
const itemList = ref(Array.from({ length: 16 }, () => reactive({
  lkey: 0, rid: 0, rname: "", rcount: 0, rcolor: 0, rDurability: 0, rDurabilityMax: 0, rSmishingLevel: 0, rAddition: 0
})))
// 4.热键key 10行
const hotkeyList = ref(Array.from({ length: 10 }, () => reactive({
  lkey: 0, key0: 0, key1: 0, key2: 0, key3: 0, key4: 0, key5: 0, key6: 0, key7: 0, key8: 0, key9: 0
})))
// 5.功能键cutkey 10行
const cutkeyList = ref(Array.from({ length: 10 }, () => reactive({
  lkey: 0, shortcutkey0: 0, shortcutkey1: 0, shortcutkey2: 0, shortcutkey3: 0, shortcutkey4: 0,
  shortcutkey5: 0, shortcutkey6: 0, shortcutkey7: 0, shortcutkey8: 0, shortcutkey9: 0
})))
// 6.任务临时变量
const questData = reactive({
  compeleteQuestNo: 0, CurrentQuestNo: 0, QuestStep: 0,
  SubCurrentQuestNo: 0, SubQueststep: 0,
  QuestTemp0: 0, QuestTemp1: 0, QuestTemp2: 0, QuestTemp3: 0, QuestTemp4: 0,
  QusetTemp5: 0, QusetTemp6: 0, QusetTemp7: 0, QusetTemp8: 0, QusetTemp9: 0,
  QusetTemp10: 0, QusetTemp11: 0, QusetTemp12: 0, QusetTemp13: 0, QusetTemp14: 0,
  QusetTemp15: 0, QusetTemp16: 0, QusetTemp17: 0, QusetTemp18: 0, QusetTemp19: 0
})

// ========== 解析函数1：基础属性 getbase 字符串分割赋值 ==========
function parseBaseData(dataStr) {
  if (!dataStr) return
  const arr = dataStr.split('#');
  const len = arr.length;
  const getVal = (idx) => arr[idx] ?? '';
  const getNum = (idx) => Number(arr[idx] || 0);
  // 常规字段
  roleData.name = getVal(0);
  roleData.account = getVal(1);
  roleData.id = getVal(2);
  roleData.bagPwd = getVal(3);
  roleData.teamId = getNum(4);
  roleData.school = getVal(5);
  roleData.loginTime = getVal(6);
  roleData.createTime = getVal(7);
  roleData.gender = getNum(8) === 1 ? '女' : '男';
  roleData.mapId = getNum(9);
  roleData.x = getNum(10);
  roleData.y = getNum(11);
  roleData.gold = getNum(12);
  roleData.rep = getNum(13);
  roleData.light = getNum(14);
  roleData.dark = getNum(15);
  roleData.maxVital = getNum(16);
  roleData.maxNei = getNum(17);
  roleData.maxWai = getNum(18);
  roleData.maxWu = getNum(19);
  roleData.maxHuo = getNum(20);
  roleData.talent = getNum(21);
  roleData.goodChar = getNum(22);
  roleData.badChar = getNum(23);
  roleData.adaptive = getNum(24);
  roleData.revival = getNum(25);
  roleData.immunity = getNum(26);
  roleData.haoran = getNum(27);
  roleData.nowVital = getNum(28);
  roleData.nowNei = getNum(29);
  roleData.nowWai = getNum(30);
  roleData.nowWu = getNum(31);
  roleData.nowHuo = getNum(32);
  roleData.health = getNum(33);
  roleData.satiety = getNum(34);
  roleData.poison = getNum(35);
  roleData.defHead = getNum(36);
  roleData.defHand = getNum(37);
  roleData.defLeg = getNum(38);
  roleData.extraExp = getNum(39);
  roleData.addPoint = getNum(40);
  roleData.totalPoint = getNum(41);
  roleData.grade = getNum(42);
  roleData.fashionMode = getNum(43);
  roleData.job = getNum(44);
  roleData.talentPoint = getNum(48);
  roleData.talentExp = getNum(49);
  roleData.talentLv = getNum(50);
  roleData.gen = getNum(51);
  roleData.shen = getNum(52);
  roleData.wu = getNum(53);
  roleData.wuxue = getNum(54);
  roleData.bindCoin = getNum(55);
  roleData.expRate = getNum(56);
  roleData.expTime = getNum(57);
  roleData.vipLv = getNum(58);
  roleData.vipTime = getVal(59);
  roleData.makeLv = getNum(60);
  roleData.schoolCoin = getNum(61);
  // 三魂固定取数组倒数17/16/15
  roleData.soul1 = getNum(len - 17);
  roleData.soul2 = getNum(len - 16);
  roleData.soul3 = getNum(len - 15);
}

// ========== 解析函数2：武功 getmagic 10行 lkey,rname,rskill ==========
function parseMagicData(dataStr) {
  if (!dataStr) return
  const arr = dataStr.split('#');
  let ptr = 0;
  for (let i = 0; i < 10; i++) {
    magicList.value[i].lkey = Number(arr[ptr++] || 0);
    magicList.value[i].rname = arr[ptr++] || "";
    magicList.value[i].rskill = Number(arr[ptr++] || 0);
  }
}

// ========== 解析函数3：物品 getitem 16行 lkey,rid,rname,rcount,rcolor,rDur,rDurMax,rSmithLv,rAdd ==========
function parseItemData(dataStr) {
  if (!dataStr) return
  const arr = dataStr.split('#');
  let ptr = 0;
  for (let i = 0; i < 16; i++) {
    itemList.value[i].lkey = Number(arr[ptr++] || 0);
    itemList.value[i].rid = Number(arr[ptr++] || 0);
    itemList.value[i].rname = arr[ptr++] || "";
    itemList.value[i].rcount = Number(arr[ptr++] || 0);
    itemList.value[i].rcolor = Number(arr[ptr++] || 0);
    itemList.value[i].rDurability = Number(arr[ptr++] || 0);
    itemList.value[i].rDurabilityMax = Number(arr[ptr++] || 0);
    itemList.value[i].rSmishingLevel = Number(arr[ptr++] || 0);
    itemList.value[i].rAddition = Number(arr[ptr++] || 0);
  }
}

// ========== 解析函数4：热键 getkey 10行 lkey + key0~key9 ==========
function parseHotkeyData(dataStr) {
  if (!dataStr) return
  const arr = dataStr.split('#');
  let ptr = 0;
  for (let i = 0; i < 10; i++) {
    hotkeyList.value[i].lkey = Number(arr[ptr++] || 0);
    hotkeyList.value[i].key0 = Number(arr[ptr++] || 0);
    hotkeyList.value[i].key1 = Number(arr[ptr++] || 0);
    hotkeyList.value[i].key2 = Number(arr[ptr++] || 0);
    hotkeyList.value[i].key3 = Number(arr[ptr++] || 0);
    hotkeyList.value[i].key4 = Number(arr[ptr++] || 0);
    hotkeyList.value[i].key5 = Number(arr[ptr++] || 0);
    hotkeyList.value[i].key6 = Number(arr[ptr++] || 0);
    hotkeyList.value[i].key7 = Number(arr[ptr++] || 0);
    hotkeyList.value[i].key8 = Number(arr[ptr++] || 0);
    hotkeyList.value[i].key9 = Number(arr[ptr++] || 0);
  }
}

// ========== 解析函数5：功能键 getcutkey 10行 lkey + shortcutkey0~9 ==========
function parseCutkeyData(dataStr) {
  if (!dataStr) return
  const arr = dataStr.split('#');
  let ptr = 0;
  for (let i = 0; i < 10; i++) {
    cutkeyList.value[i].lkey = Number(arr[ptr++] || 0);
    cutkeyList.value[i].shortcutkey0 = Number(arr[ptr++] || 0);
    cutkeyList.value[i].shortcutkey1 = Number(arr[ptr++] || 0);
    cutkeyList.value[i].shortcutkey2 = Number(arr[ptr++] || 0);
    cutkeyList.value[i].shortcutkey3 = Number(arr[ptr++] || 0);
    cutkeyList.value[i].shortcutkey4 = Number(arr[ptr++] || 0);
    cutkeyList.value[i].shortcutkey5 = Number(arr[ptr++] || 0);
    cutkeyList.value[i].shortcutkey6 = Number(arr[ptr++] || 0);
    cutkeyList.value[i].shortcutkey7 = Number(arr[ptr++] || 0);
    cutkeyList.value[i].shortcutkey8 = Number(arr[ptr++] || 0);
    cutkeyList.value[i].shortcutkey9 = Number(arr[ptr++] || 0);
  }
}

// ========== 解析函数6：临时任务 gettemp ==========
function parseQuestData(dataStr) {
  if (!dataStr) return
  const arr = dataStr.split('#');
  const getNum = (idx) => Number(arr[idx] || 0);
  questData.compeleteQuestNo = getNum(0);
  questData.CurrentQuestNo = getNum(1);
  questData.QuestStep = getNum(2);
  questData.SubCurrentQuestNo = getNum(3);
  questData.SubQueststep = getNum(4);
  questData.QuestTemp0 = getNum(5);
  questData.QuestTemp1 = getNum(6);
  questData.QuestTemp2 = getNum(7);
  questData.QuestTemp3 = getNum(8);
  questData.QuestTemp4 = getNum(9);
  questData.QusetTemp5 = getNum(10);
  questData.QusetTemp6 = getNum(11);
  questData.QusetTemp7 = getNum(12);
  questData.QusetTemp8 = getNum(13);
  questData.QusetTemp9 = getNum(14);
  questData.QusetTemp10 = getNum(15);
  questData.QusetTemp11 = getNum(16);
  questData.QusetTemp12 = getNum(17);
  questData.QusetTemp13 = getNum(18);
  questData.QusetTemp14 = getNum(19);
  questData.QusetTemp15 = getNum(20);
  questData.QusetTemp16 = getNum(21);
  questData.QusetTemp17 = getNum(22);
  questData.QusetTemp18 = getNum(23);
  questData.QusetTemp19 = getNum(24);
}

// 测试按钮填充基础数据
function fillTestData() {
  const testStr = "洋洋#洋洋#17736725655##0##2026-06-30#2026-06-15#0#1#471#471#1850#0#46680#0#2198#0#0#0#0#0#0#0#0#0#0#0#2198#1925#2151#2151#4187#4203#4203#4203#4203#4203#4203#0#0#0#1#0#0#0#0#0#0#0#0#0#0#0#0#0#0#0#0#1899-12-30#0#0";
  parseBaseData(testStr)
  dbRes.value = "基础测试数据填充完成！三魂取自字符串倒数17、16、15位"
  dbSubTab.value = 'base'
}

// 加载角色列表
function searchUser() {
  if (!searchName.value) {
    dbRes.value = '请输入角色名字查询'
    return
  }
  roleList.value = [searchName.value + "_1", searchName.value]
  dbRes.value = "角色列表加载完成"
}

// 点击右侧列表回填搜索框
function selectRoleItem(name) {
  selectRole.value = name
  searchName.value = name
}

// 统一请求DB接口，自动切换面板并解析对应数据
function reqDbApi(apiName) {
  if (!selectRole.value) {
    dbRes.value = "请先在右侧选择角色"
    return
  }
  const url = `http://127.0.0.1:8090/api/${apiName}?name=${selectRole.value}`
  fetch(url)
    .then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      return res.text()
    })
    .then(ret => {
      dbRes.value = ret
      if (!ret) return
      // 根据接口名分发解析函数+切换子面板
      switch (apiName) {
        case 'getbase':
          parseBaseData(ret)
          dbSubTab.value = 'base'
          break
        case 'getmagic':
          parseMagicData(ret)
          dbSubTab.value = 'magic'
          break
        case 'getitem':
          parseItemData(ret)
          dbSubTab.value = 'item'
          break
        case 'getkey':
          parseHotkeyData(ret)
          dbSubTab.value = 'key'
          break
        case 'getcutkey':
          parseCutkeyData(ret)
          dbSubTab.value = 'cutkey'
          break
        case 'gettemp':
          parseQuestData(ret)
          dbSubTab.value = 'temp'
          break
      }
    })
    .catch(err => dbRes.value = "请求异常：" + err.message)
}

/*
defineExpose({
  dbSubTab,
  searchName,
  roleList,
  selectRole,
  dbRes,
  roleData,
  magicList,
  itemList,
  hotkeyList,
  cutkeyList,
  questData,
  parseBaseData,
  parseMagicData,
  parseItemData,
  parseHotkeyData,
  parseCutkeyData,
  parseQuestData,
  fillTestData,
  searchUser,
  selectRoleItem,
  reqDbApi
})
*/
</script>

<style scoped>
.function-page {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}
.btn-group {
  display: flex;
  gap: 15px;
  margin-bottom: 30px;
}
.func-btn {
  padding: 12px 24px;
  font-size: 16px;
  border: none;
  border-radius: 8px;
  background: #f0f2f5;
  cursor: pointer;
  transition: all 0.3s;
}
.func-btn:hover {
  background: #e5e6eb;
}
.func-btn.active {
  background: #409eff;
  color: #fff;
}
.page-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  min-height: 400px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.tab-panel {
  width: 100%;
}
h3 {
  margin-top: 0;
  margin-bottom: 20px;
  color: #333;
}
.form-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}
.input-box {
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  width: 260px;
}
.submit-btn,
.search-main-btn {
  padding: 8px 18px;
  background: #409eff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.res-text {
  margin-top: 16px;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
}
.btn-row {
  display: flex;
  gap: 16px;
}
.open-btn {
  padding: 10px 22px;
  background: #67c23a;
  color: #fff;
  border: none;
  border-radius: 4px;
}
.close-btn {
  padding: 10px 22px;
  background: #f56c6c;
  color: #fff;
  border: none;
  border-radius: 4px;
}
.back-dashboard-btn {
  padding: 6px 14px;
  border: 1px solid #409eff;
  background: #fff;
  color: #409eff;
  border-radius: 4px;
  cursor: pointer;
}
.back-dashboard-btn:hover {
  background: #409eff;
  color: #fff;
}

</style>